import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { businessTimeZone } from "../../utils/date"


export const getAccountingPayments = createAsyncThunk('accounting/getPayments', async ({
  limit,
  offset,
  filters,
  filterListId,
  sortField = '',
  sortOrder = '',
}, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/payments/accounting/payments`, {
      params: {
        limit,
        filterListId,
        offset,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
        sortField,
        sortOrder,
      },
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get payments'
    return rejectWithValue(errorMessage)
  }
})

export const getAccountingSchedule = createAsyncThunk('payments/getSchedule', async ({
  limit,
  offset,
  filters,
  filterListId,
  sortField = '',
  sortOrder = '',
}, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/payments/accounting/schedule`, {
      params: {
        filterListId,
        limit,
        offset,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
        sortField,
        sortOrder,
      },
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get payments'
    return rejectWithValue(errorMessage)
  }
})

export const getAccountingDashboard = createAsyncThunk('accounting/paymentDashboard', async ({ filters, filterListId }, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/payments/accounting/dashboard`, {
      params: {
        filterListId,
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
      },
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to get payments'
    return rejectWithValue(errorMessage)
  }
})

export const getAccountingCSV = createAsyncThunk('payments/accounting/download-csv', async ({ filters }, { rejectWithValue }) => {
  try {
    let result = filters && encodeURI(JSON.stringify(filters))

    const response = await apiRequest.get(`/payments/accounting/download-csv`, {
      params: {
        filters: result === "%22%22" ? "" : result,
        timezone: businessTimeZone,
      }
    })
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error.errors[0].message || 'Failed to export csv'
    return rejectWithValue(errorMessage)
  }
})